"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconHouse = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      points: "19 9.8 19 4.5 16 4.5 16 7.1 12 3.5 2 12.5 5 12.5 5 20.5 10 20.5 10 14.5 14 14.5 14 20.5 19 20.5 19 12.5 22 12.5"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconHouse')(IconHouse);